import * as React from 'react';

import { RowProps, useController } from './row.controller';
import { Flex } from '@common/components/Flex';
import { TextField } from './components/text-field';
import { FieldType } from '@common/dto/field/type';
import { isNumber, stringHasInteger } from '@common/utils/string';
import Dropdown, { DROPDOWN_NO_VALUE } from '@common/containers/fields/Dropdown';
import { Checkbox } from '@common/components/checkbox';
import cx from 'classnames';

import './row.styles.scss';

export const Row: React.FC<RowProps> = (props) => {
  const { columns, selected } = props;

  const {
    handleClick,
  } = useController(props);

  return (
    <Flex 
      className={cx("DatasheetsResultDatasheetTableFieldRow", { 'DatasheetsResultDatasheetTableFieldRow--selected': selected })} 
      onClick={handleClick}
    >
      {columns.map((column) => {
        const value = undefined;
        const fieldType = column.fieldtype.typeid;
        let fieldComponent = (
          <TextField 
            defaultValue={value} 
            onChange={console.log}
          />
        );

        if (fieldType === FieldType.number) {
          fieldComponent = (
            <TextField 
              defaultValue={value} 
              onChange={console.log}
              validate={(x) => isNumber(x)}
            />
          ); 
        }

        if (fieldType === FieldType.integer) {
          fieldComponent = (
            <TextField 
              defaultValue={value} 
              onChange={console.log}
              validate={(x) => stringHasInteger(x, {
                allowEmpty: true,
                allowNegative: false,
                allowZero: true,
              })}
            />
          ); 
        }

        if (fieldType === FieldType.date) {
          fieldComponent = (
            <TextField 
              type="date"
              defaultValue={value} 
              onChange={console.log}
            />
          );
        }

        if (fieldType === FieldType.dropdown) {
          fieldComponent = (
            <Dropdown 
              fullWidth
              defaultValue={value} 
              className="NewTableFilters__filter-type"
              selectedValue={value ?? DROPDOWN_NO_VALUE}
              searchable={false}
              options={[]}
              onValueChanged={console.log}
            />
          );
        }

        if (fieldType === FieldType.checkbox) {
          fieldComponent = (
            <Checkbox 
              defaultChecked={value} 
              onChange={console.log}
            />
          );
        }

        return (
          <div 
            // style={{ width: column.width }} 
            key={column.fieldid} 
            className="DatasheetsResultDatasheetTableFieldRow__cell"
          >
            {fieldComponent}
          </div>
        );
      })}
    </Flex>
  );
};